<div class="table-print">
  <thead class="table-header">
    <tr>
      <td>
        <div class="header-space">
          <div class="left-part">
            <span class="logo-wrap">
              <img [src]="competitionLogo">
            </span>
            <span class="comp-name">{{ competitionName }}</span>
          </div>
          <div class="right-part">
            <span class="title print-compiled-header-title">{{ compiledHeaderTitle }}</span>
          </div>
        </div>
      </td>
    </tr>
  </thead>
  <div class="table-body">
    <div class="table-row">
      <div class="table-data content-main-wrapper">
        <div class="main" [ngClass]="{'loginPageVisible': loginPageVisible}">
          <app-notification-bar></app-notification-bar>
          <div class="notification-impersonation" *ngIf="ssoAuthService.impersonationInfo$ | async as impersonationInfo">
            <div class="content">
              <span class="icon-wrapper">
                <span class="icon material-icons-round">info</span>
              </span>
              <div class="content-inner">
                <p><b>{{ impersonationInfo.impersonatedByFullName }}</b> you are now impersonating <b>{{ impersonationInfo.impersonatedFullName }}</b>.</p>
              </div>
              <button
                (click)="stopImpersonate()"
                class="end-impersonation button button-secondary button-secondary--smaller"
              >
                End Impersonation <span class="icon material-icons-outlined">group_off</span>
              </button>
            </div>
          </div>
          
          <div *ngIf="!hideNav && (ssoAuthService.currentRpUser$ | async)"
            class="custom-navbar-outer-wrapper on-top"
            #customNavbarOuterWrapper
            (click)="customNavbarOuterWrapperOnTop()"
            [ngClass]="{'impersonation-bar-shown': impersonationBannerShown}"
          >
            <app-nav-bar class="navbar navbar-expand-lg navbar-light"></app-nav-bar>
          </div>

          <div
            class="login-page-background"
            *ngIf="loginPageVisible && loginPageBackgroundImage"
            [ngClass]="{'shown': loginPageVisible && loginPageBackgroundImage}"
            [ngStyle]="{'background-image': loginPageBackgroundImage}"
          ></div>

          <div class="custom-main-outer-wrapper">
            <div
              class="pcoded-main-container"
              id="pcoded-main-container"
              [ngClass]="{'dashboard-active': isDashboardActive}"
            >
              <div class="main-container-shape-on-scroll"></div>
              <div class="pcoded-wrapper">
                <div class="pcoded-content">
                  <div class="pcoded-inner-content">
                    <div class="main-body">
                      <div class="page-loader">
                        <div class="loader-inner"></div>
                      </div>
                      <div class="page-wrapper" [ngClass]="{'stopLoader': pageWrapperStopLoader }">
                        <router-outlet></router-outlet>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <tfoot class="table-footer">
    <tr>
      <td>
        <div class="footer-space"></div>
      </td>
    </tr>
  </tfoot>
</div>
<app-loader id="loader"></app-loader>
<app-footer class="footer"></app-footer>
<div class="footer-print">
  <div class="logo-wrap">
    <img src="assets/images/carrot-logo.png" width="129">
  </div>
  <div class="text-wrap">
    &copy; {{ currentYear }} All rights reserved
  </div>
</div>
<ng-container>
  <app-scroll-to-top
    class="to-top"
    [ngClass]="{
      'show-scrollTop': windowScrolled
    }"
    (scrollToTop)="onScrollToTop()"
  >
  </app-scroll-to-top>
</ng-container>
